import '../Content/css/product_detail.css'
import '../Content/js/product-nav.js'



// WEBPACK FOOTER //
// ./E:/airwheel.net/entry/product_detail.js